import { useAppSelector, useAppTranslation } from "@/utils";
import { Flex, Typography } from "@payping/web-components";
import { useCountDown } from "@/utils/hooks/useCountdown";
import GetOrderCancelOrder from "../CancelOrder";

const PayGetOrderLayoutHeader = () => {
  const { t } = useAppTranslation();

  const order = useAppSelector((state) => state.bnplConsumer.order);
  const remainTime = useCountDown(new Date(order.expireDate ?? new Date()));

  return (
    <Flex align="center" className="tw:w-ful tw:max-h-8 tw:min-h-8">
      <GetOrderCancelOrder />
      <Typography.Title level={5} className="tw:m-0!">
        {t("pay.getOrder.title")}
      </Typography.Title>
      <div className="tw:mr-auto tw:p-2!">
        <Typography.Text color="cta">{remainTime.format}</Typography.Text>
      </div>
    </Flex>
  );
};
export default PayGetOrderLayoutHeader;
